/**
 * The generic module-event address carries only where its Back control should
 * return. This is a closed view-context vocabulary, never a URL: the event
 * read remains the source of the Patient id, and the module workspace still
 * decides whether a chart link may be offered to the current account.
 */
export interface ModuleEventSearch {
  origin?: 'patient'
}

/** Drop every unknown value and key at the route boundary. */
export function validateModuleEventSearch(search: Record<string, unknown>): ModuleEventSearch {
  return search['origin'] === 'patient' ? { origin: 'patient' } : {}
}
